import PropTypes from 'prop-types';

import css from 'styles/components/checkout/melody/sectionTitle.scss';

const SectionTitle = ({ id, title, step }, { testId = f => f }) => (
  <h2 className={css.header} data-test-id={testId('sectionTitle')} id={id}>
    { !!step && `${step}. `}
    { title }
  </h2>
);

SectionTitle.contextTypes = {
  testId: PropTypes.func
};

export default SectionTitle;
